// extracted by mini-css-extract-plugin
export default {"icon":"CheckedIcon__icon___T3xXL","checked":"CheckedIcon__checked___IOHCa","notChecked":"CheckedIcon__notChecked___HpoBK","indeterminate":"CheckedIcon__indeterminate___qujVX"};